/// <amd-module name="Test/CloudLoadTest/Components/LoadTestView" />
import * as React from "react";
import { getAssetLocation } from "VSS/Platform/Location";
import { ZeroData } from "VSSUI/ZeroData";
import * as Resources from "Test/CloudLoadTest/Resources";
import { VssComponent, Components, IVssComponentContext } from "VSS/Platform/Layout";

export class LoadTestViewComponent extends VssComponent {

    constructor(props: {}, context?: any) {
        super(props, context);
    }

    public render(): JSX.Element {
        return (
            <div className="load-test-view">
                <ZeroData
                    imagePath={getAssetLocation(
                        this.context.pageContext,
                        "ms.vss-test-web/common-content/no-results-image.png"
                    )}
                    imageAltText={Resources.CltShutdownMessageText}
                    primaryText={Resources.CltShutdownMessageText}
                    secondaryText={
                        <span>
                            {Resources.ClickMessagePreText} {" "}
                            <a
                                target="_blank"
                                href="https://go.microsoft.com/fwlink/?linkid=2061309"
                                aria-label={Resources.ClickMessageAriaLabelText}
                            >
                                {Resources.ClickMessageLinkText}
                            </a>{" "}
                            {Resources.ClickMessagePostText}
                        </span>
                    }
                />
            </div>
        )
    };
}

Components.add("cloudLoadTest", LoadTestViewComponent);